import React, { useEffect, useState } from 'react';
import { Link, NavLink, Outlet, Navigate, useNavigate } from 'react-router-dom';
import { getAdminKey, clearAdminKey } from '../../lib/api';
import { LayoutDashboard, Package, ShoppingBag, MessageSquare, Mail, LogOut, ExternalLink } from 'lucide-react';
import { Button } from '../../components/ui/button';

const AdminLayout = () => {
  const navigate = useNavigate();
  if (!getAdminKey()) return <Navigate to="/admin/login" replace />;

  const logout = () => {
    clearAdminKey();
    navigate('/admin/login', { replace: true });
  };

  const navItems = [
    { to: '/admin', label: 'Overview', icon: LayoutDashboard, end: true },
    { to: '/admin/products', label: 'Products', icon: Package },
    { to: '/admin/orders', label: 'Orders', icon: ShoppingBag },
    { to: '/admin/messages', label: 'Messages', icon: MessageSquare },
    { to: '/admin/newsletter', label: 'Newsletter', icon: Mail },
  ];

  return (
    <div className="min-h-screen bg-neutral-100">
      <header className="bg-[#0a0a0a] text-white">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 bg-[#bfff00] rounded flex items-center justify-center"><span className="text-black font-black">F</span></div>
            <div>
              <div className="font-black">Admin Console</div>
              <div className="text-[10px] text-neutral-400 tracking-widest">FITNESS PRO NUTRITION</div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Link to="/" target="_blank" className="text-xs text-neutral-300 hover:text-[#bfff00] flex items-center gap-1"><ExternalLink className="w-3.5 h-3.5" /> View Site</Link>
            <Button variant="ghost" size="sm" onClick={logout} className="text-neutral-300 hover:text-white hover:bg-neutral-800"><LogOut className="w-4 h-4 mr-1" /> Logout</Button>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 py-6 grid grid-cols-1 md:grid-cols-[220px_1fr] gap-6">
        <nav className="bg-white rounded-lg p-3 h-fit shadow-sm">
          {navItems.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} className={({ isActive }) => `flex items-center gap-2 px-3 py-2.5 rounded text-sm font-semibold transition-colors ${isActive ? 'bg-[#0a0a0a] text-white' : 'text-neutral-700 hover:bg-neutral-100'}`}>
              <Icon className="w-4 h-4" /> {label}
            </NavLink>
          ))}
        </nav>

        <main className="min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
